import { Box, Grid, Typography } from '@mui/material';
import { BreadcrumbsNavigation } from '~/components';
import { HomeIcon } from '~/icons';
import { NoticeBanner } from './components';

const AdminSettingsPage = () => {
  return (
    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
      <BreadcrumbsNavigation
        navigationConfig={[
          { name: <HomeIcon />, path: '' },
          {
            name: 'Admin Settings',
            path: '..',
          },
        ]}
      />
      <Typography variant="h3" mb="2rem">
        Admin Settings
      </Typography>
      <Grid container spacing={2}>
        <Grid size={{ xs: 6 }}>
          <NoticeBanner />
        </Grid>
      </Grid>
    </Box>
  );
};

export default AdminSettingsPage;
